import { render, staticRenderFns } from "./PageTitleIcon.vue?vue&type=template&id=0207fabd"
import script from "./PageTitleIcon.vue?vue&type=script&lang=ts"
export * from "./PageTitleIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports